import { __extends } from "tslib";
import React from 'react';
import s from './view-wrapper.scss';
import { Loader } from 'wix-style-react';
export var FetchStatus;
(function (FetchStatus) {
    FetchStatus["FETCHING"] = "fetching";
    FetchStatus["ERROR"] = "error";
    FetchStatus["COMPLETE"] = "pending";
})(FetchStatus || (FetchStatus = {}));
var ViewWrapper = /** @class */ (function (_super) {
    __extends(ViewWrapper, _super);
    function ViewWrapper(props) {
        return _super.call(this, props) || this;
    }
    ViewWrapper.prototype.render = function () {
        return (React.createElement("div", { className: s.viewWrapperContainer }, this.props.fetchStatus === FetchStatus.ERROR ? (React.createElement(Error, { PlaceHolder: this.props.ErrorPlaceholder })) : this.props.fetchStatus === FetchStatus.FETCHING ? (React.createElement(FetchingMode, { PlaceHolder: this.props.FetchPlaceholder })) : (this.props.children)));
    };
    return ViewWrapper;
}(React.Component));
export { ViewWrapper };
var Error = function (props) {
    var PlaceHolder = props.PlaceHolder;
    return (React.createElement("div", { "data-testid": "view-wrapper-container", className: s.errorLoader }, PlaceHolder ? (React.createElement(PlaceHolder, null)) : (React.createElement(Loader, { dataHook: "error-loader", status: "error", statusMessage: "Content From Our Amazing Product(s)", text: "This is an Error Handling" }))));
};
var FetchingMode = function (props) {
    var PlaceHolder = props.PlaceHolder;
    return (React.createElement("div", { "data-testid": "view-wrapper-container", className: s.fetchLoader }, PlaceHolder ? (React.createElement(PlaceHolder, null)) : (React.createElement(Loader, { dataHook: "fetching-loader", status: "loading", statusMessage: "Content From Our Amazing Product(s)", text: "Fetching some stunning data" }))));
};
//# sourceMappingURL=view-wrapper.js.map